import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import App from './App';
import { onFlowEvent } from './utils/brevo';
import completeOrder, { returnToPaidOrder } from './utils/complete-order';
import './styles/tokens.css';

// Same production keys the existing mtm-react-app plugin's /subscribe-v2
// route uses (App.js) — not new credentials, this is a second mount of the
// same checkout flow on its own bundle, not a second account.
const RECAPTCHA_KEY = '6Ld0eagbAAAAAIk2WXayOcbZBTflQ4Z6DdTbcAUV';
const RECURLY_PUBLIC_KEY = 'ewr1-UOuCoHJCcOF92pDf26zeQ7';

const container = document.getElementById('mtm_react_app_v3');
// Back off the thank-you page: go back to it instead of drawing a spent payment form.
if (!returnToPaidOrder()) {
  const root = createRoot(container);
  root.render(
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_KEY}
      scriptProps={{ async: false, defer: false, appendTo: 'head', nonce: undefined }}
    >
      <RecurlyProvider publicKey={RECURLY_PUBLIC_KEY} required={['cvv']} currency="USD">
        <Elements>
          <App onEvent={onFlowEvent} onComplete={completeOrder} />
        </Elements>
      </RecurlyProvider>
    </GoogleReCaptchaProvider>,
  );
}
